import { Card, CardBody, Col, Container, Row } from 'reactstrap'
import CreateNewLockerForm from '../../../../Componant/Application/Project/master/CreateNewLockerForm'


const LockerCreateContainer = () => {
  return (
    <Container fluid>
      <Row>
        <Col sm="12">
          <Card>
            <CardBody>
              <CreateNewLockerForm />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default LockerCreateContainer